/* eslint-disable */
// prettier-ignore
import * as Types from '../../../../graphql/__generated__';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MyOrders_AcknowledgeFinalAllocationMutationVariables = Types.Exact<{
  indicationId: Types.Scalars['UUID']['input'];
  offeringId: Types.Scalars['UUID']['input'];
  version: Types.Scalars['String']['input'];
}>;

export type MyOrders_AcknowledgeFinalAllocationMutation = {
  readonly __typename?: 'Mutation';
  readonly acknowledgeCoveredInstitutionalIndication: {
    readonly __typename?: 'CoveredInstitutionalIndication';
    readonly id: string;
    readonly acknowledgementStatus?: Types.AllocationAcknowledgement | null;
  };
};

export type MyOrders_CoveredIndicationsChangedSubscriptionVariables = Types.Exact<{
  [key: string]: never;
}>;

export type MyOrders_CoveredIndicationsChangedSubscription = {
  readonly __typename?: 'Subscription';
  readonly coveredIndicationsChanged: {
    readonly __typename?: 'CoveredIndicationChangeSet';
    readonly removedIds: ReadonlyArray<string>;
    readonly fullRefreshOfferingIds: ReadonlyArray<string>;
    readonly added: ReadonlyArray<{
      readonly __typename?: 'CoveredInstitutionalIndicationWithAttestation';
      readonly id: string;
      readonly offeringId: string;
      readonly status: Types.IndicationStatus;
      readonly type: Types.InstitutionalIndicationOrderType;
      readonly trancheId?: string | null;
      readonly currencyCode?: string | null;
      readonly instrumentId?: string | null;
      readonly version: string;
      readonly investorAttestationStatus: Types.AttestationFormStatus;
      readonly investorQibStatus: Types.AttestationFormStatus;
      readonly demandMax?: number | null;
      readonly demandMaxNotional?: number | null;
      readonly allocationShares?: number | null;
      readonly allocationVersion?: string | null;
      readonly allocationCurrency?: number | null;
      readonly allocationPercentOfOffering?: number | null;
      readonly indicationPercentFill?: number | null;
      readonly investorReplyStatus?: Types.AllocationAcknowledgement | null;
      readonly duplicateOfIndicationId?: string | null;
      readonly duplicateIndicationIds: ReadonlyArray<string>;
      readonly billingAndDeliveryAgentCmgEntityKey?: string | null;
      readonly investorInformation: {
        readonly __typename?: 'InvestorInformation';
        readonly bankInvestorName?: string | null;
        readonly bankInvestorKey?: string | null;
        readonly cmgEntityKey: string;
        readonly cmgEntityName: string;
        readonly contactName?: string | null;
        readonly contactEmail?: string | null;
        readonly isOnPlatform: boolean;
      };
      readonly interestLevels: ReadonlyArray<{
        readonly __typename?: 'InterestLevel';
        readonly interestUnit: Types.InterestLevelInterestUnit;
        readonly interestQuantity: number;
        readonly limitPrice?: number | null;
        readonly limitType?: Types.InterestLevelLimitType | null;
        readonly coupon?: number | null;
        readonly premium?: number | null;
        readonly percentageOfPar?: number | null;
      }>;
      readonly acknowledgedBy?: {
        readonly __typename?: 'UserInfo';
        readonly name: string;
        readonly email?: string | null;
      } | null;
      readonly allocationAcknowledgedBy?: {
        readonly __typename?: 'UserInfo';
        readonly name: string;
        readonly email?: string | null;
      } | null;
      readonly auditInfo: {
        readonly __typename?: 'AuditInfo';
        readonly modifiedByFirmKey?: string | null;
        readonly modifiedAt: string;
        readonly createdAt: string;
        readonly modifiedByUserEmail?: string | null;
        readonly createdByUserEmail?: string | null;
      };
      readonly prospectusDeliverySummary: {
        readonly __typename?: 'ProspectusDeliverySummary';
        readonly totalEmailCount: number;
        readonly sentEmailCount: number;
        readonly failedEmailCount: number;
        readonly inProgressEmailCount: number;
        readonly overallStatus: Types.ProspectusDeliveryStatus;
        readonly overallStatusDisplayValue: string;
      };
      readonly acknowledgements: ReadonlyArray<{
        readonly __typename?: 'IndicationAcknowledgement';
        readonly isRevised: boolean;
        readonly manager: {
          readonly __typename?: 'FirmInfo';
          readonly firmKey: string;
          readonly firmDisplayName?: string | null;
        };
      }>;
    }>;
    readonly updated: ReadonlyArray<{
      readonly __typename?: 'CoveredInstitutionalIndicationWithAttestation';
      readonly id: string;
      readonly offeringId: string;
      readonly status: Types.IndicationStatus;
      readonly type: Types.InstitutionalIndicationOrderType;
      readonly trancheId?: string | null;
      readonly currencyCode?: string | null;
      readonly instrumentId?: string | null;
      readonly version: string;
      readonly investorAttestationStatus: Types.AttestationFormStatus;
      readonly investorQibStatus: Types.AttestationFormStatus;
      readonly demandMax?: number | null;
      readonly demandMaxNotional?: number | null;
      readonly allocationShares?: number | null;
      readonly allocationVersion?: string | null;
      readonly allocationCurrency?: number | null;
      readonly allocationPercentOfOffering?: number | null;
      readonly indicationPercentFill?: number | null;
      readonly investorReplyStatus?: Types.AllocationAcknowledgement | null;
      readonly duplicateOfIndicationId?: string | null;
      readonly duplicateIndicationIds: ReadonlyArray<string>;
      readonly billingAndDeliveryAgentCmgEntityKey?: string | null;
      readonly investorInformation: {
        readonly __typename?: 'InvestorInformation';
        readonly bankInvestorName?: string | null;
        readonly bankInvestorKey?: string | null;
        readonly cmgEntityKey: string;
        readonly cmgEntityName: string;
        readonly contactName?: string | null;
        readonly contactEmail?: string | null;
        readonly isOnPlatform: boolean;
      };
      readonly interestLevels: ReadonlyArray<{
        readonly __typename?: 'InterestLevel';
        readonly interestUnit: Types.InterestLevelInterestUnit;
        readonly interestQuantity: number;
        readonly limitPrice?: number | null;
        readonly limitType?: Types.InterestLevelLimitType | null;
        readonly coupon?: number | null;
        readonly premium?: number | null;
        readonly percentageOfPar?: number | null;
      }>;
      readonly acknowledgedBy?: {
        readonly __typename?: 'UserInfo';
        readonly name: string;
        readonly email?: string | null;
      } | null;
      readonly allocationAcknowledgedBy?: {
        readonly __typename?: 'UserInfo';
        readonly name: string;
        readonly email?: string | null;
      } | null;
      readonly auditInfo: {
        readonly __typename?: 'AuditInfo';
        readonly modifiedByFirmKey?: string | null;
        readonly modifiedAt: string;
        readonly createdAt: string;
        readonly modifiedByUserEmail?: string | null;
        readonly createdByUserEmail?: string | null;
      };
      readonly prospectusDeliverySummary: {
        readonly __typename?: 'ProspectusDeliverySummary';
        readonly totalEmailCount: number;
        readonly sentEmailCount: number;
        readonly failedEmailCount: number;
        readonly inProgressEmailCount: number;
        readonly overallStatus: Types.ProspectusDeliveryStatus;
        readonly overallStatusDisplayValue: string;
      };
      readonly acknowledgements: ReadonlyArray<{
        readonly __typename?: 'IndicationAcknowledgement';
        readonly isRevised: boolean;
        readonly manager: {
          readonly __typename?: 'FirmInfo';
          readonly firmKey: string;
          readonly firmDisplayName?: string | null;
        };
      }>;
    }>;
  };
};

export type MyOrders_GridCoveredAttestationStatuses_AttestationStatusPartsFragment = {
  readonly __typename?: 'AttestationStatus';
  readonly cmgEntityKey: string;
  readonly status: Types.AttestationFormStatus;
};

export type MyOrders_GridCoveredAttestationStatusesQueryVariables = Types.Exact<{
  cmgEntityKeys: ReadonlyArray<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;

export type MyOrders_GridCoveredAttestationStatusesQuery = {
  readonly __typename?: 'Query';
  readonly coveredAttestationStatuses: ReadonlyArray<{
    readonly __typename?: 'AttestationStatus';
    readonly cmgEntityKey: string;
    readonly status: Types.AttestationFormStatus;
  } | null>;
};

export type MyOrders_CoveredIndications_InvestorInformationPartsFragment = {
  readonly __typename?: 'InvestorInformation';
  readonly bankInvestorName?: string | null;
  readonly bankInvestorKey?: string | null;
  readonly cmgEntityKey: string;
  readonly cmgEntityName: string;
  readonly contactName?: string | null;
  readonly contactEmail?: string | null;
  readonly isOnPlatform: boolean;
};

export type MyOrders_CoveredIndications_InterestLevelPartsFragment = {
  readonly __typename?: 'InterestLevel';
  readonly interestUnit: Types.InterestLevelInterestUnit;
  readonly interestQuantity: number;
  readonly limitPrice?: number | null;
  readonly limitType?: Types.InterestLevelLimitType | null;
  readonly coupon?: number | null;
  readonly premium?: number | null;
  readonly percentageOfPar?: number | null;
};

export type MyOrders_CoveredIndications_AuditInfoPartsFragment = {
  readonly __typename?: 'AuditInfo';
  readonly modifiedByFirmKey?: string | null;
  readonly modifiedAt: string;
  readonly createdAt: string;
  readonly modifiedByUserEmail?: string | null;
  readonly createdByUserEmail?: string | null;
};

export type MyOrders_CoveredIndications_LatestEmailStatusPartsFragment = {
  readonly __typename?: 'LatestEmailStatus';
  readonly status: Types.EmailDeliveryStatus;
};

export type MyOrders_CoveredIndications_ProspectusDeliverySummaryPartsFragment = {
  readonly __typename?: 'ProspectusDeliverySummary';
  readonly totalEmailCount: number;
  readonly sentEmailCount: number;
  readonly failedEmailCount: number;
  readonly inProgressEmailCount: number;
  readonly overallStatus: Types.ProspectusDeliveryStatus;
  readonly overallStatusDisplayValue: string;
};

export type MyOrders_CoveredIndications_InvestorDeliveryStatusPartsFragment = {
  readonly __typename?: 'InvestorDeliveryStatus';
  readonly id: string;
  readonly offeringId: string;
  readonly cmgEntityKey: string;
  readonly overallDeliveryStatus: Types.ProspectusDeliveryStatus;
  readonly sentEmailCount: number;
  readonly totalEmailCount: number;
  readonly failedEmailCount: number;
  readonly inProgressEmailCount: number;
};

export type MyOrders_CoveredIndications_IndicationAcknowledgementPartsFragment = {
  readonly __typename?: 'IndicationAcknowledgement';
  readonly isRevised: boolean;
  readonly manager: {
    readonly __typename?: 'FirmInfo';
    readonly firmKey: string;
    readonly firmDisplayName?: string | null;
  };
};

export type MyOrders_CoveredIndications_CoveredInstitutionalIndicationPartsFragment = {
  readonly __typename?: 'CoveredInstitutionalIndicationWithAttestation';
  readonly id: string;
  readonly offeringId: string;
  readonly status: Types.IndicationStatus;
  readonly type: Types.InstitutionalIndicationOrderType;
  readonly trancheId?: string | null;
  readonly currencyCode?: string | null;
  readonly instrumentId?: string | null;
  readonly version: string;
  readonly investorAttestationStatus: Types.AttestationFormStatus;
  readonly investorQibStatus: Types.AttestationFormStatus;
  readonly demandMax?: number | null;
  readonly demandMaxNotional?: number | null;
  readonly allocationShares?: number | null;
  readonly allocationVersion?: string | null;
  readonly allocationCurrency?: number | null;
  readonly allocationPercentOfOffering?: number | null;
  readonly indicationPercentFill?: number | null;
  readonly investorReplyStatus?: Types.AllocationAcknowledgement | null;
  readonly duplicateOfIndicationId?: string | null;
  readonly duplicateIndicationIds: ReadonlyArray<string>;
  readonly billingAndDeliveryAgentCmgEntityKey?: string | null;
  readonly investorInformation: {
    readonly __typename?: 'InvestorInformation';
    readonly bankInvestorName?: string | null;
    readonly bankInvestorKey?: string | null;
    readonly cmgEntityKey: string;
    readonly cmgEntityName: string;
    readonly contactName?: string | null;
    readonly contactEmail?: string | null;
    readonly isOnPlatform: boolean;
  };
  readonly interestLevels: ReadonlyArray<{
    readonly __typename?: 'InterestLevel';
    readonly interestUnit: Types.InterestLevelInterestUnit;
    readonly interestQuantity: number;
    readonly limitPrice?: number | null;
    readonly limitType?: Types.InterestLevelLimitType | null;
    readonly coupon?: number | null;
    readonly premium?: number | null;
    readonly percentageOfPar?: number | null;
  }>;
  readonly acknowledgedBy?: {
    readonly __typename?: 'UserInfo';
    readonly name: string;
    readonly email?: string | null;
  } | null;
  readonly allocationAcknowledgedBy?: {
    readonly __typename?: 'UserInfo';
    readonly name: string;
    readonly email?: string | null;
  } | null;
  readonly auditInfo: {
    readonly __typename?: 'AuditInfo';
    readonly modifiedByFirmKey?: string | null;
    readonly modifiedAt: string;
    readonly createdAt: string;
    readonly modifiedByUserEmail?: string | null;
    readonly createdByUserEmail?: string | null;
  };
  readonly prospectusDeliverySummary: {
    readonly __typename?: 'ProspectusDeliverySummary';
    readonly totalEmailCount: number;
    readonly sentEmailCount: number;
    readonly failedEmailCount: number;
    readonly inProgressEmailCount: number;
    readonly overallStatus: Types.ProspectusDeliveryStatus;
    readonly overallStatusDisplayValue: string;
  };
  readonly acknowledgements: ReadonlyArray<{
    readonly __typename?: 'IndicationAcknowledgement';
    readonly isRevised: boolean;
    readonly manager: {
      readonly __typename?: 'FirmInfo';
      readonly firmKey: string;
      readonly firmDisplayName?: string | null;
    };
  }>;
};

export type MyOrders_SyndicateManagerPartsFragment = {
  readonly __typename?: 'ManagerFull';
  readonly cmgEntityKey: string;
  readonly firmName: string;
  readonly firmNameAbbreviation?: string | null;
  readonly entitlements?: ReadonlyArray<string> | null;
};

export type MyOrders_InstrumentPartsFragment = {
  readonly __typename?: 'InstrumentFull';
  readonly id: string;
  readonly countryCode?: string | null;
  readonly sellingRestrictions?: Types.SellingRestrictions | null;
};

export type MyOrders_OfferingPartsFragment = {
  readonly __typename?: 'OfferingFull';
  readonly id: string;
  readonly type: Types.OfferingType;
  readonly status: Types.OfferingStatus;
  readonly isInternal: boolean;
  readonly pricingInstrumentStockSymbol?: string | null;
  readonly isExecutingOnPlatform: boolean;
  readonly pricingCurrencyCode: string;
  readonly pricingInstrumentId?: string | null;
  readonly issuer: { readonly __typename?: 'IssuerFull'; readonly name: string };
  readonly timing: { readonly __typename?: 'TimingFull'; readonly pricingDate?: string | null };
  readonly security: { readonly __typename?: 'SecurityFull'; readonly type: Types.SecurityType };
  readonly syndicate?: {
    readonly __typename?: 'SyndicateFull';
    readonly managers: ReadonlyArray<{
      readonly __typename?: 'ManagerFull';
      readonly cmgEntityKey: string;
      readonly firmName: string;
      readonly firmNameAbbreviation?: string | null;
      readonly entitlements?: ReadonlyArray<string> | null;
    }>;
  } | null;
  readonly instruments: ReadonlyArray<{
    readonly __typename?: 'InstrumentFull';
    readonly id: string;
    readonly countryCode?: string | null;
    readonly sellingRestrictions?: Types.SellingRestrictions | null;
  }>;
  readonly terms: {
    readonly __typename?: 'TermsFull';
    readonly filings: ReadonlyArray<{
      readonly __typename?: 'FilingFull';
      readonly filingType: Types.FilingType;
      readonly id: string;
      readonly offerPrice?: number | null;
      readonly couponTalkLow?: number | null;
      readonly couponTalkHigh?: number | null;
      readonly premiumTalkLow?: number | null;
      readonly premiumTalkHigh?: number | null;
    }>;
  };
  readonly orderBookConfiguration?: {
    readonly __typename?: 'OrderBookConfigurationFull';
    readonly isIndicationPriceAsPercentageParEnabled: boolean;
  } | null;
  readonly orderBookFull: {
    readonly __typename?: 'OrderBookFull';
    readonly coveredIndications?: ReadonlyArray<{
      readonly __typename?: 'CoveredInstitutionalIndicationWithAttestation';
      readonly id: string;
      readonly offeringId: string;
      readonly status: Types.IndicationStatus;
      readonly type: Types.InstitutionalIndicationOrderType;
      readonly trancheId?: string | null;
      readonly currencyCode?: string | null;
      readonly instrumentId?: string | null;
      readonly version: string;
      readonly investorAttestationStatus: Types.AttestationFormStatus;
      readonly investorQibStatus: Types.AttestationFormStatus;
      readonly demandMax?: number | null;
      readonly demandMaxNotional?: number | null;
      readonly allocationShares?: number | null;
      readonly allocationVersion?: string | null;
      readonly allocationCurrency?: number | null;
      readonly allocationPercentOfOffering?: number | null;
      readonly indicationPercentFill?: number | null;
      readonly investorReplyStatus?: Types.AllocationAcknowledgement | null;
      readonly duplicateOfIndicationId?: string | null;
      readonly duplicateIndicationIds: ReadonlyArray<string>;
      readonly billingAndDeliveryAgentCmgEntityKey?: string | null;
      readonly investorInformation: {
        readonly __typename?: 'InvestorInformation';
        readonly bankInvestorName?: string | null;
        readonly bankInvestorKey?: string | null;
        readonly cmgEntityKey: string;
        readonly cmgEntityName: string;
        readonly contactName?: string | null;
        readonly contactEmail?: string | null;
        readonly isOnPlatform: boolean;
      };
      readonly interestLevels: ReadonlyArray<{
        readonly __typename?: 'InterestLevel';
        readonly interestUnit: Types.InterestLevelInterestUnit;
        readonly interestQuantity: number;
        readonly limitPrice?: number | null;
        readonly limitType?: Types.InterestLevelLimitType | null;
        readonly coupon?: number | null;
        readonly premium?: number | null;
        readonly percentageOfPar?: number | null;
      }>;
      readonly acknowledgedBy?: {
        readonly __typename?: 'UserInfo';
        readonly name: string;
        readonly email?: string | null;
      } | null;
      readonly allocationAcknowledgedBy?: {
        readonly __typename?: 'UserInfo';
        readonly name: string;
        readonly email?: string | null;
      } | null;
      readonly auditInfo: {
        readonly __typename?: 'AuditInfo';
        readonly modifiedByFirmKey?: string | null;
        readonly modifiedAt: string;
        readonly createdAt: string;
        readonly modifiedByUserEmail?: string | null;
        readonly createdByUserEmail?: string | null;
      };
      readonly prospectusDeliverySummary: {
        readonly __typename?: 'ProspectusDeliverySummary';
        readonly totalEmailCount: number;
        readonly sentEmailCount: number;
        readonly failedEmailCount: number;
        readonly inProgressEmailCount: number;
        readonly overallStatus: Types.ProspectusDeliveryStatus;
        readonly overallStatusDisplayValue: string;
      };
      readonly acknowledgements: ReadonlyArray<{
        readonly __typename?: 'IndicationAcknowledgement';
        readonly isRevised: boolean;
        readonly manager: {
          readonly __typename?: 'FirmInfo';
          readonly firmKey: string;
          readonly firmDisplayName?: string | null;
        };
      }>;
    }> | null;
  };
};

export type MyOrders_Filings_ConvertibleTalkRangesPartsFragment = {
  readonly __typename?: 'FilingFull';
  readonly couponTalkLow?: number | null;
  readonly couponTalkHigh?: number | null;
  readonly premiumTalkLow?: number | null;
  readonly premiumTalkHigh?: number | null;
};

export type MyOrders_PublishedOfferingsQueryVariables = Types.Exact<{
  skip?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  take?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  includeTestOfferings: Types.Scalars['Boolean']['input'];
  where?: Types.InputMaybe<Types.OfferingFullFilterInput>;
}>;

export type MyOrders_PublishedOfferingsQuery = {
  readonly __typename?: 'Query';
  readonly publishedOfferings?: {
    readonly __typename?: 'PublishedOfferingsCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'OfferingFull';
      readonly id: string;
      readonly type: Types.OfferingType;
      readonly status: Types.OfferingStatus;
      readonly isInternal: boolean;
      readonly pricingInstrumentStockSymbol?: string | null;
      readonly isExecutingOnPlatform: boolean;
      readonly pricingCurrencyCode: string;
      readonly pricingInstrumentId?: string | null;
      readonly issuer: { readonly __typename?: 'IssuerFull'; readonly name: string };
      readonly timing: { readonly __typename?: 'TimingFull'; readonly pricingDate?: string | null };
      readonly security: {
        readonly __typename?: 'SecurityFull';
        readonly type: Types.SecurityType;
      };
      readonly syndicate?: {
        readonly __typename?: 'SyndicateFull';
        readonly managers: ReadonlyArray<{
          readonly __typename?: 'ManagerFull';
          readonly cmgEntityKey: string;
          readonly firmName: string;
          readonly firmNameAbbreviation?: string | null;
          readonly entitlements?: ReadonlyArray<string> | null;
        }>;
      } | null;
      readonly instruments: ReadonlyArray<{
        readonly __typename?: 'InstrumentFull';
        readonly id: string;
        readonly countryCode?: string | null;
        readonly sellingRestrictions?: Types.SellingRestrictions | null;
      }>;
      readonly terms: {
        readonly __typename?: 'TermsFull';
        readonly filings: ReadonlyArray<{
          readonly __typename?: 'FilingFull';
          readonly filingType: Types.FilingType;
          readonly id: string;
          readonly offerPrice?: number | null;
          readonly couponTalkLow?: number | null;
          readonly couponTalkHigh?: number | null;
          readonly premiumTalkLow?: number | null;
          readonly premiumTalkHigh?: number | null;
        }>;
      };
      readonly orderBookConfiguration?: {
        readonly __typename?: 'OrderBookConfigurationFull';
        readonly isIndicationPriceAsPercentageParEnabled: boolean;
      } | null;
      readonly orderBookFull: {
        readonly __typename?: 'OrderBookFull';
        readonly coveredIndications?: ReadonlyArray<{
          readonly __typename?: 'CoveredInstitutionalIndicationWithAttestation';
          readonly id: string;
          readonly offeringId: string;
          readonly status: Types.IndicationStatus;
          readonly type: Types.InstitutionalIndicationOrderType;
          readonly trancheId?: string | null;
          readonly currencyCode?: string | null;
          readonly instrumentId?: string | null;
          readonly version: string;
          readonly investorAttestationStatus: Types.AttestationFormStatus;
          readonly investorQibStatus: Types.AttestationFormStatus;
          readonly demandMax?: number | null;
          readonly demandMaxNotional?: number | null;
          readonly allocationShares?: number | null;
          readonly allocationVersion?: string | null;
          readonly allocationCurrency?: number | null;
          readonly allocationPercentOfOffering?: number | null;
          readonly indicationPercentFill?: number | null;
          readonly investorReplyStatus?: Types.AllocationAcknowledgement | null;
          readonly duplicateOfIndicationId?: string | null;
          readonly duplicateIndicationIds: ReadonlyArray<string>;
          readonly billingAndDeliveryAgentCmgEntityKey?: string | null;
          readonly investorInformation: {
            readonly __typename?: 'InvestorInformation';
            readonly bankInvestorName?: string | null;
            readonly bankInvestorKey?: string | null;
            readonly cmgEntityKey: string;
            readonly cmgEntityName: string;
            readonly contactName?: string | null;
            readonly contactEmail?: string | null;
            readonly isOnPlatform: boolean;
          };
          readonly interestLevels: ReadonlyArray<{
            readonly __typename?: 'InterestLevel';
            readonly interestUnit: Types.InterestLevelInterestUnit;
            readonly interestQuantity: number;
            readonly limitPrice?: number | null;
            readonly limitType?: Types.InterestLevelLimitType | null;
            readonly coupon?: number | null;
            readonly premium?: number | null;
            readonly percentageOfPar?: number | null;
          }>;
          readonly acknowledgedBy?: {
            readonly __typename?: 'UserInfo';
            readonly name: string;
            readonly email?: string | null;
          } | null;
          readonly allocationAcknowledgedBy?: {
            readonly __typename?: 'UserInfo';
            readonly name: string;
            readonly email?: string | null;
          } | null;
          readonly auditInfo: {
            readonly __typename?: 'AuditInfo';
            readonly modifiedByFirmKey?: string | null;
            readonly modifiedAt: string;
            readonly createdAt: string;
            readonly modifiedByUserEmail?: string | null;
            readonly createdByUserEmail?: string | null;
          };
          readonly prospectusDeliverySummary: {
            readonly __typename?: 'ProspectusDeliverySummary';
            readonly totalEmailCount: number;
            readonly sentEmailCount: number;
            readonly failedEmailCount: number;
            readonly inProgressEmailCount: number;
            readonly overallStatus: Types.ProspectusDeliveryStatus;
            readonly overallStatusDisplayValue: string;
          };
          readonly acknowledgements: ReadonlyArray<{
            readonly __typename?: 'IndicationAcknowledgement';
            readonly isRevised: boolean;
            readonly manager: {
              readonly __typename?: 'FirmInfo';
              readonly firmKey: string;
              readonly firmDisplayName?: string | null;
            };
          }>;
        }> | null;
      };
    }> | null;
    readonly pageInfo: {
      readonly __typename?: 'CollectionSegmentInfo';
      readonly hasNextPage: boolean;
    };
  } | null;
};

export type MyOrders_UnAcknowledgeFinalAllocationMutationVariables = Types.Exact<{
  indicationId: Types.Scalars['UUID']['input'];
  offeringId: Types.Scalars['UUID']['input'];
  version: Types.Scalars['String']['input'];
}>;

export type MyOrders_UnAcknowledgeFinalAllocationMutation = {
  readonly __typename?: 'Mutation';
  readonly unacknowledgeCoveredInstitutionalFinalAllocation: {
    readonly __typename?: 'CoveredInstitutionalIndication';
    readonly id: string;
    readonly acknowledgementStatus?: Types.AllocationAcknowledgement | null;
  };
};

export const MyOrders_GridCoveredAttestationStatuses_AttestationStatusPartsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'MyOrders_GridCoveredAttestationStatuses_AttestationStatusParts',
      },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AttestationStatus' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'cmgEntityKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const MyOrders_CoveredIndications_LatestEmailStatusPartsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MyOrders_CoveredIndications_LatestEmailStatusParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'LatestEmailStatus' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'status' } }],
      },
    },
  ],
} as unknown as DocumentNode;
export const MyOrders_CoveredIndications_InvestorDeliveryStatusPartsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MyOrders_CoveredIndications_InvestorDeliveryStatusParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorDeliveryStatus' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'offeringId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cmgEntityKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'overallDeliveryStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentEmailCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalEmailCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedEmailCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inProgressEmailCount' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const MyOrders_SyndicateManagerPartsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MyOrders_SyndicateManagerParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ManagerFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'cmgEntityKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmNameAbbreviation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entitlements' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const MyOrders_InstrumentPartsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MyOrders_InstrumentParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InstrumentFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sellingRestrictions' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const MyOrders_Filings_ConvertibleTalkRangesPartsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MyOrders_Filings_ConvertibleTalkRangesParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FilingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'couponTalkLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'couponTalkHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premiumTalkLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premiumTalkHigh' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const MyOrders_OfferingPartsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MyOrders_OfferingParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'OfferingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInternal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'timing' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'pricingDate' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'security' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'pricingInstrumentStockSymbol' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isExecutingOnPlatform' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pricingCurrencyCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pricingInstrumentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'syndicate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'managers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MyOrders_SyndicateManagerParts' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instruments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MyOrders_InstrumentParts' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'terms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'filings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filingType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'offerPrice' } },
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'MyOrders_Filings_ConvertibleTalkRangesParts',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orderBookConfiguration' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isIndicationPriceAsPercentageParEnabled' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orderBookFull' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'coveredIndications' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'MyOrders_CoveredIndications_CoveredInstitutionalIndicationParts',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MyOrders_CoveredIndications_InvestorInformationParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'bankInvestorName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bankInvestorKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cmgEntityKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cmgEntityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contactName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contactEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isOnPlatform' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MyOrders_CoveredIndications_InterestLevelParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InterestLevel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'interestUnit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'interestQuantity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'limitPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'limitType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coupon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premium' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percentageOfPar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MyOrders_CoveredIndications_AuditInfoParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AuditInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedByFirmKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedByUserEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdByUserEmail' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MyOrders_CoveredIndications_ProspectusDeliverySummaryParts' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ProspectusDeliverySummary' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'totalEmailCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentEmailCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedEmailCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inProgressEmailCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'overallStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'overallStatusDisplayValue' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MyOrders_CoveredIndications_IndicationAcknowledgementParts' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'IndicationAcknowledgement' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isRevised' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'manager' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'firmKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firmDisplayName' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'MyOrders_CoveredIndications_CoveredInstitutionalIndicationParts',
      },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CoveredInstitutionalIndicationWithAttestation' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'offeringId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'trancheId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instrumentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'investorAttestationStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'investorQibStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'investorInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'MyOrders_CoveredIndications_InvestorInformationParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interestLevels' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MyOrders_CoveredIndications_InterestLevelParts' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'demandMax' } },
          { kind: 'Field', name: { kind: 'Name', value: 'demandMaxNotional' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'acknowledgedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'allocationShares' } },
          { kind: 'Field', name: { kind: 'Name', value: 'allocationVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'allocationCurrency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'allocationPercentOfOffering' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allocationAcknowledgedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'indicationPercentFill' } },
          { kind: 'Field', name: { kind: 'Name', value: 'investorReplyStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duplicateOfIndicationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duplicateIndicationIds' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'auditInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MyOrders_CoveredIndications_AuditInfoParts' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'billingAndDeliveryAgentCmgEntityKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prospectusDeliverySummary' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'MyOrders_CoveredIndications_ProspectusDeliverySummaryParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'acknowledgements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'MyOrders_CoveredIndications_IndicationAcknowledgementParts',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MyOrders_SyndicateManagerParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ManagerFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'cmgEntityKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmNameAbbreviation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entitlements' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MyOrders_InstrumentParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InstrumentFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sellingRestrictions' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MyOrders_Filings_ConvertibleTalkRangesParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FilingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'couponTalkLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'couponTalkHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premiumTalkLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premiumTalkHigh' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const MyOrders_AcknowledgeFinalAllocationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MyOrders_AcknowledgeFinalAllocation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'indicationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offeringId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'version' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'acknowledgeCoveredInstitutionalIndication' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'indicationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'indicationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offeringId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offeringId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'versionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'version' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'acknowledgementStatus' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type MyOrders_AcknowledgeFinalAllocationMutationFn = Apollo.MutationFunction<
  MyOrders_AcknowledgeFinalAllocationMutation,
  MyOrders_AcknowledgeFinalAllocationMutationVariables
>;

/**
 * __useMyOrders_AcknowledgeFinalAllocationMutation__
 *
 * To run a mutation, you first call `useMyOrders_AcknowledgeFinalAllocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyOrders_AcknowledgeFinalAllocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myOrdersAcknowledgeFinalAllocationMutation, { data, loading, error }] = useMyOrders_AcknowledgeFinalAllocationMutation({
 *   variables: {
 *      indicationId: // value for 'indicationId'
 *      offeringId: // value for 'offeringId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useMyOrders_AcknowledgeFinalAllocationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MyOrders_AcknowledgeFinalAllocationMutation,
    MyOrders_AcknowledgeFinalAllocationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MyOrders_AcknowledgeFinalAllocationMutation,
    MyOrders_AcknowledgeFinalAllocationMutationVariables
  >(MyOrders_AcknowledgeFinalAllocationDocument, options);
}
export type MyOrders_AcknowledgeFinalAllocationMutationHookResult = ReturnType<
  typeof useMyOrders_AcknowledgeFinalAllocationMutation
>;
export type MyOrders_AcknowledgeFinalAllocationMutationResult =
  Apollo.MutationResult<MyOrders_AcknowledgeFinalAllocationMutation>;
export type MyOrders_AcknowledgeFinalAllocationMutationOptions = Apollo.BaseMutationOptions<
  MyOrders_AcknowledgeFinalAllocationMutation,
  MyOrders_AcknowledgeFinalAllocationMutationVariables
>;
export const MyOrders_CoveredIndicationsChangedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'MyOrders_CoveredIndicationsChanged' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'coveredIndicationsChanged' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'added' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'MyOrders_CoveredIndications_CoveredInstitutionalIndicationParts',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'updated' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'MyOrders_CoveredIndications_CoveredInstitutionalIndicationParts',
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'removedIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullRefreshOfferingIds' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MyOrders_CoveredIndications_InvestorInformationParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'bankInvestorName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bankInvestorKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cmgEntityKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cmgEntityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contactName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contactEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isOnPlatform' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MyOrders_CoveredIndications_InterestLevelParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InterestLevel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'interestUnit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'interestQuantity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'limitPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'limitType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coupon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premium' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percentageOfPar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MyOrders_CoveredIndications_AuditInfoParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AuditInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedByFirmKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedByUserEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdByUserEmail' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MyOrders_CoveredIndications_ProspectusDeliverySummaryParts' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ProspectusDeliverySummary' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'totalEmailCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentEmailCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedEmailCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inProgressEmailCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'overallStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'overallStatusDisplayValue' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MyOrders_CoveredIndications_IndicationAcknowledgementParts' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'IndicationAcknowledgement' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isRevised' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'manager' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'firmKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firmDisplayName' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'MyOrders_CoveredIndications_CoveredInstitutionalIndicationParts',
      },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CoveredInstitutionalIndicationWithAttestation' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'offeringId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'trancheId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instrumentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'investorAttestationStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'investorQibStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'investorInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'MyOrders_CoveredIndications_InvestorInformationParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interestLevels' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MyOrders_CoveredIndications_InterestLevelParts' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'demandMax' } },
          { kind: 'Field', name: { kind: 'Name', value: 'demandMaxNotional' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'acknowledgedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'allocationShares' } },
          { kind: 'Field', name: { kind: 'Name', value: 'allocationVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'allocationCurrency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'allocationPercentOfOffering' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allocationAcknowledgedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'indicationPercentFill' } },
          { kind: 'Field', name: { kind: 'Name', value: 'investorReplyStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duplicateOfIndicationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duplicateIndicationIds' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'auditInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MyOrders_CoveredIndications_AuditInfoParts' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'billingAndDeliveryAgentCmgEntityKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prospectusDeliverySummary' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'MyOrders_CoveredIndications_ProspectusDeliverySummaryParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'acknowledgements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'MyOrders_CoveredIndications_IndicationAcknowledgementParts',
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMyOrders_CoveredIndicationsChangedSubscription__
 *
 * To run a query within a React component, call `useMyOrders_CoveredIndicationsChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMyOrders_CoveredIndicationsChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyOrders_CoveredIndicationsChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useMyOrders_CoveredIndicationsChangedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    MyOrders_CoveredIndicationsChangedSubscription,
    MyOrders_CoveredIndicationsChangedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    MyOrders_CoveredIndicationsChangedSubscription,
    MyOrders_CoveredIndicationsChangedSubscriptionVariables
  >(MyOrders_CoveredIndicationsChangedDocument, options);
}
export type MyOrders_CoveredIndicationsChangedSubscriptionHookResult = ReturnType<
  typeof useMyOrders_CoveredIndicationsChangedSubscription
>;
export type MyOrders_CoveredIndicationsChangedSubscriptionResult =
  Apollo.SubscriptionResult<MyOrders_CoveredIndicationsChangedSubscription>;
export const MyOrders_GridCoveredAttestationStatusesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MyOrders_GridCoveredAttestationStatuses' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cmgEntityKeys' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'coveredAttestationStatuses' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cmgEntityKeys' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cmgEntityKeys' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'MyOrders_GridCoveredAttestationStatuses_AttestationStatusParts',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'MyOrders_GridCoveredAttestationStatuses_AttestationStatusParts',
      },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AttestationStatus' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'cmgEntityKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMyOrders_GridCoveredAttestationStatusesQuery__
 *
 * To run a query within a React component, call `useMyOrders_GridCoveredAttestationStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyOrders_GridCoveredAttestationStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyOrders_GridCoveredAttestationStatusesQuery({
 *   variables: {
 *      cmgEntityKeys: // value for 'cmgEntityKeys'
 *   },
 * });
 */
export function useMyOrders_GridCoveredAttestationStatusesQuery(
  baseOptions: Apollo.QueryHookOptions<
    MyOrders_GridCoveredAttestationStatusesQuery,
    MyOrders_GridCoveredAttestationStatusesQueryVariables
  > &
    (
      | { variables: MyOrders_GridCoveredAttestationStatusesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MyOrders_GridCoveredAttestationStatusesQuery,
    MyOrders_GridCoveredAttestationStatusesQueryVariables
  >(MyOrders_GridCoveredAttestationStatusesDocument, options);
}
export function useMyOrders_GridCoveredAttestationStatusesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyOrders_GridCoveredAttestationStatusesQuery,
    MyOrders_GridCoveredAttestationStatusesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MyOrders_GridCoveredAttestationStatusesQuery,
    MyOrders_GridCoveredAttestationStatusesQueryVariables
  >(MyOrders_GridCoveredAttestationStatusesDocument, options);
}
// @ts-ignore
export function useMyOrders_GridCoveredAttestationStatusesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MyOrders_GridCoveredAttestationStatusesQuery,
    MyOrders_GridCoveredAttestationStatusesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  MyOrders_GridCoveredAttestationStatusesQuery,
  MyOrders_GridCoveredAttestationStatusesQueryVariables
>;
export function useMyOrders_GridCoveredAttestationStatusesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MyOrders_GridCoveredAttestationStatusesQuery,
        MyOrders_GridCoveredAttestationStatusesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  MyOrders_GridCoveredAttestationStatusesQuery | undefined,
  MyOrders_GridCoveredAttestationStatusesQueryVariables
>;
export function useMyOrders_GridCoveredAttestationStatusesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MyOrders_GridCoveredAttestationStatusesQuery,
        MyOrders_GridCoveredAttestationStatusesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MyOrders_GridCoveredAttestationStatusesQuery,
    MyOrders_GridCoveredAttestationStatusesQueryVariables
  >(MyOrders_GridCoveredAttestationStatusesDocument, options);
}
export type MyOrders_GridCoveredAttestationStatusesQueryHookResult = ReturnType<
  typeof useMyOrders_GridCoveredAttestationStatusesQuery
>;
export type MyOrders_GridCoveredAttestationStatusesLazyQueryHookResult = ReturnType<
  typeof useMyOrders_GridCoveredAttestationStatusesLazyQuery
>;
export type MyOrders_GridCoveredAttestationStatusesSuspenseQueryHookResult = ReturnType<
  typeof useMyOrders_GridCoveredAttestationStatusesSuspenseQuery
>;
export type MyOrders_GridCoveredAttestationStatusesQueryResult = Apollo.QueryResult<
  MyOrders_GridCoveredAttestationStatusesQuery,
  MyOrders_GridCoveredAttestationStatusesQueryVariables
>;
export const MyOrders_PublishedOfferingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MyOrders_PublishedOfferings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeTestOfferings' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'OfferingFullFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publishedOfferings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skip' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'take' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeTestOfferings' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'includeTestOfferings' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MyOrders_OfferingParts' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MyOrders_CoveredIndications_InvestorInformationParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'bankInvestorName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bankInvestorKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cmgEntityKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cmgEntityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contactName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'contactEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isOnPlatform' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MyOrders_CoveredIndications_InterestLevelParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InterestLevel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'interestUnit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'interestQuantity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'limitPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'limitType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coupon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premium' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percentageOfPar' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MyOrders_CoveredIndications_AuditInfoParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AuditInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedByFirmKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'modifiedByUserEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdByUserEmail' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MyOrders_CoveredIndications_ProspectusDeliverySummaryParts' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ProspectusDeliverySummary' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'totalEmailCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentEmailCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failedEmailCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inProgressEmailCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'overallStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'overallStatusDisplayValue' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MyOrders_CoveredIndications_IndicationAcknowledgementParts' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'IndicationAcknowledgement' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isRevised' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'manager' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'firmKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firmDisplayName' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'MyOrders_CoveredIndications_CoveredInstitutionalIndicationParts',
      },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CoveredInstitutionalIndicationWithAttestation' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'offeringId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'trancheId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instrumentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'investorAttestationStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'investorQibStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'investorInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'MyOrders_CoveredIndications_InvestorInformationParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'interestLevels' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MyOrders_CoveredIndications_InterestLevelParts' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'demandMax' } },
          { kind: 'Field', name: { kind: 'Name', value: 'demandMaxNotional' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'acknowledgedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'allocationShares' } },
          { kind: 'Field', name: { kind: 'Name', value: 'allocationVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'allocationCurrency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'allocationPercentOfOffering' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allocationAcknowledgedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'indicationPercentFill' } },
          { kind: 'Field', name: { kind: 'Name', value: 'investorReplyStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duplicateOfIndicationId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duplicateIndicationIds' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'auditInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MyOrders_CoveredIndications_AuditInfoParts' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'billingAndDeliveryAgentCmgEntityKey' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prospectusDeliverySummary' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'MyOrders_CoveredIndications_ProspectusDeliverySummaryParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'acknowledgements' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'MyOrders_CoveredIndications_IndicationAcknowledgementParts',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MyOrders_SyndicateManagerParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ManagerFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'cmgEntityKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmNameAbbreviation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entitlements' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MyOrders_InstrumentParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InstrumentFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sellingRestrictions' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MyOrders_OfferingParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'OfferingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isInternal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'timing' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'pricingDate' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'security' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'pricingInstrumentStockSymbol' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isExecutingOnPlatform' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pricingCurrencyCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pricingInstrumentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'syndicate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'managers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MyOrders_SyndicateManagerParts' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instruments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MyOrders_InstrumentParts' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'terms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'filings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'filingType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'offerPrice' } },
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'MyOrders_Filings_ConvertibleTalkRangesParts',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orderBookConfiguration' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isIndicationPriceAsPercentageParEnabled' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orderBookFull' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'coveredIndications' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'MyOrders_CoveredIndications_CoveredInstitutionalIndicationParts',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MyOrders_Filings_ConvertibleTalkRangesParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FilingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'couponTalkLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'couponTalkHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premiumTalkLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premiumTalkHigh' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMyOrders_PublishedOfferingsQuery__
 *
 * To run a query within a React component, call `useMyOrders_PublishedOfferingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyOrders_PublishedOfferingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyOrders_PublishedOfferingsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      includeTestOfferings: // value for 'includeTestOfferings'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useMyOrders_PublishedOfferingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    MyOrders_PublishedOfferingsQuery,
    MyOrders_PublishedOfferingsQueryVariables
  > &
    ({ variables: MyOrders_PublishedOfferingsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MyOrders_PublishedOfferingsQuery,
    MyOrders_PublishedOfferingsQueryVariables
  >(MyOrders_PublishedOfferingsDocument, options);
}
export function useMyOrders_PublishedOfferingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyOrders_PublishedOfferingsQuery,
    MyOrders_PublishedOfferingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MyOrders_PublishedOfferingsQuery,
    MyOrders_PublishedOfferingsQueryVariables
  >(MyOrders_PublishedOfferingsDocument, options);
}
// @ts-ignore
export function useMyOrders_PublishedOfferingsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MyOrders_PublishedOfferingsQuery,
    MyOrders_PublishedOfferingsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  MyOrders_PublishedOfferingsQuery,
  MyOrders_PublishedOfferingsQueryVariables
>;
export function useMyOrders_PublishedOfferingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MyOrders_PublishedOfferingsQuery,
        MyOrders_PublishedOfferingsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  MyOrders_PublishedOfferingsQuery | undefined,
  MyOrders_PublishedOfferingsQueryVariables
>;
export function useMyOrders_PublishedOfferingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MyOrders_PublishedOfferingsQuery,
        MyOrders_PublishedOfferingsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MyOrders_PublishedOfferingsQuery,
    MyOrders_PublishedOfferingsQueryVariables
  >(MyOrders_PublishedOfferingsDocument, options);
}
export type MyOrders_PublishedOfferingsQueryHookResult = ReturnType<
  typeof useMyOrders_PublishedOfferingsQuery
>;
export type MyOrders_PublishedOfferingsLazyQueryHookResult = ReturnType<
  typeof useMyOrders_PublishedOfferingsLazyQuery
>;
export type MyOrders_PublishedOfferingsSuspenseQueryHookResult = ReturnType<
  typeof useMyOrders_PublishedOfferingsSuspenseQuery
>;
export type MyOrders_PublishedOfferingsQueryResult = Apollo.QueryResult<
  MyOrders_PublishedOfferingsQuery,
  MyOrders_PublishedOfferingsQueryVariables
>;
export const MyOrders_UnAcknowledgeFinalAllocationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MyOrders_UnAcknowledgeFinalAllocation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'indicationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offeringId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'version' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unacknowledgeCoveredInstitutionalFinalAllocation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'indicationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'indicationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offeringId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offeringId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'versionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'version' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'acknowledgementStatus' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type MyOrders_UnAcknowledgeFinalAllocationMutationFn = Apollo.MutationFunction<
  MyOrders_UnAcknowledgeFinalAllocationMutation,
  MyOrders_UnAcknowledgeFinalAllocationMutationVariables
>;

/**
 * __useMyOrders_UnAcknowledgeFinalAllocationMutation__
 *
 * To run a mutation, you first call `useMyOrders_UnAcknowledgeFinalAllocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyOrders_UnAcknowledgeFinalAllocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myOrdersUnAcknowledgeFinalAllocationMutation, { data, loading, error }] = useMyOrders_UnAcknowledgeFinalAllocationMutation({
 *   variables: {
 *      indicationId: // value for 'indicationId'
 *      offeringId: // value for 'offeringId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useMyOrders_UnAcknowledgeFinalAllocationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MyOrders_UnAcknowledgeFinalAllocationMutation,
    MyOrders_UnAcknowledgeFinalAllocationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MyOrders_UnAcknowledgeFinalAllocationMutation,
    MyOrders_UnAcknowledgeFinalAllocationMutationVariables
  >(MyOrders_UnAcknowledgeFinalAllocationDocument, options);
}
export type MyOrders_UnAcknowledgeFinalAllocationMutationHookResult = ReturnType<
  typeof useMyOrders_UnAcknowledgeFinalAllocationMutation
>;
export type MyOrders_UnAcknowledgeFinalAllocationMutationResult =
  Apollo.MutationResult<MyOrders_UnAcknowledgeFinalAllocationMutation>;
export type MyOrders_UnAcknowledgeFinalAllocationMutationOptions = Apollo.BaseMutationOptions<
  MyOrders_UnAcknowledgeFinalAllocationMutation,
  MyOrders_UnAcknowledgeFinalAllocationMutationVariables
>;

import { makeMockResponse } from '../../../../graphql/mock-response';

export const makeMyOrders_GridCoveredAttestationStatusesMockResponse = makeMockResponse<
  MyOrders_GridCoveredAttestationStatusesQueryVariables,
  MyOrders_GridCoveredAttestationStatusesQuery
>(MyOrders_GridCoveredAttestationStatusesDocument);

export const makeMyOrders_PublishedOfferingsMockResponse = makeMockResponse<
  MyOrders_PublishedOfferingsQueryVariables,
  MyOrders_PublishedOfferingsQuery
>(MyOrders_PublishedOfferingsDocument);
